export enum EStorage {
    MENU = 'cnseg_menu',
    FAVORITES = 'favorites'
}

export enum ELocalStorage{
    STORAGE = 'cnseg_storage',
}